module.exports = __webpack_public_path__ + "static/media/listen-1.242d18f6.jpg";